import { InformeCumplimiento } from '../../model/informe/informe-cumplimiento';
import { CausaRechazo } from '../../model/aprobar-rechazar-informe/causa-rechazo';
import { OffsetPageResponse } from '../../model/common/offset-page-response.dto';
import {
  AprobarInformesRequest,
  BuscarInformesEnviadosRequest,
  RechazarInformesRequest,
  ResultadoOperacion
} from '../../model/aprobar-rechazar-informe/aprobar-rechazar-request';

export abstract class AprobarRechazarInformeRepository {
  abstract buscar(request: BuscarInformesEnviadosRequest): Promise<OffsetPageResponse<InformeCumplimiento>>;
  abstract listarCausasRechazo(): Promise<CausaRechazo[]>;
  abstract rechazar(request: RechazarInformesRequest): Promise<ResultadoOperacion>;
  abstract aprobar(request: AprobarInformesRequest): Promise<ResultadoOperacion>;
  abstract consultarUrlPanorama(cdpanoramas: string): Promise<{ url: string }>;
}
